import React from 'react';
import { FaShieldAlt, FaClock, FaGlobe } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const scrollToDevices = () => {
    const element = document.getElementById('devices');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Rastreamento GPS
            <span className="hero-highlight"> Profissional</span>
          </h1>
          <p className="hero-subtitle">
            Soluções completas de rastreamento veicular com tecnologia de ponta. 
            Proteja seu patrimônio com dispositivos de alta qualidade e suporte especializado.
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToDevices} className="btn-primary">
              Ver Dispositivos
            </button>
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary"
            >
              Solicitar Orçamento
            </button>
          </div>
        </div>

        <div className="hero-features">
          <div className="feature-card">
            <div className="feature-icon">
              <FaShieldAlt />
            </div>
            <h3>Segurança Total</h3>
            <p>Proteção 24/7 com alertas em tempo real</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaClock />
            </div>
            <h3>Rastreamento Real-Time</h3>
            <p>Localização precisa a qualquer momento</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaGlobe />
            </div>
            <h3>Cobertura Global</h3>
            <p>Monitoramento em qualquer lugar do mundo</p>
          </div>
        </div>
      </div>

      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>
    </section>
  );
};

export default Hero;

